import { pslClient } from "@/common/http-common";
import {
  API_REFRESH_D2C_SESSION,
  API_START_D2C_SESSION,
} from "@/constants/api.constants.js";
import { PRODUCT } from "@/constants/common.constants";

class SessionService {
  /**
   * Start d2c session with the QuoteAndBuyApi
   * @param {string} leadId
   * @returns {Promise<{LeadId: number, BrokerId: number, BrokerCode: string, BranchId: number, BranchNo: string, ProductId: number}>}
   */
  async startD2CSession(leadId, quoteReference, productId = PRODUCT.Home) {
    const options = {
      params: {
        leadId,
        quoteReference,
        productId: productId,
      },
      withCredentials: true,
    };
    const url = `${API_START_D2C_SESSION}`;
    const response = await pslClient.get(url, options);
    return response.data;
  }

  async refreshD2CSession() {
    const url = `${API_REFRESH_D2C_SESSION}`;
    const options = { withCredentials: true };
    const response = await pslClient.get(url, options);
    return response.data;
  }
}

export default new SessionService();
